import { type RefObject, useCallback, useEffect, useState } from "react";

import { useEscape } from "./use_escape";

// "+ Add section" pointing mode: on until Escape, a press anywhere but the
// elements it keeps (`keep`: its toggle and hint), Insert here's + among them,
// or a section added (`count`).
export const usePointing = (
  keep: ReadonlyArray<RefObject<HTMLElement | null>>,
  count: number,
) => {
  const [pointing, setPointing] = useState(false);
  const stop = useCallback(() => setPointing(false), []);
  useEscape(pointing, stop);
  useEffect(stop, [count, stop]);

  useEffect(() => {
    if (!pointing) return;

    const press = (event: MouseEvent) => {
      const target = event.target as Node;
      if (keep.some((ref) => ref.current?.contains(target))) return;
      stop();
    };
    document.addEventListener("mousedown", press);
    return () => document.removeEventListener("mousedown", press);
  }, [pointing, keep, stop]);

  return [pointing, () => setPointing(!pointing)] as const;
};
